export default __webpack_public_path__ + "static/media/lottery-banners-ms.fd0bb552.webp";